// Spanisches Wörterbuch — `Dict` erzwingt Vollständigkeit.
import type { Dict } from "./de";

export const es: Dict = {
  meta: {
    title: "Pulpo: La carta digital para tu restaurante",
    description:
      "Tus clientes escanean el código QR en la mesa y ven tu carta en el móvil: en su idioma, con fotos y precios actualizados.",
  },
  nav: { login: "Iniciar sesión" },
  hero: {
    eyebrow: "La carta digital para tu restaurante",
    title: "Tu carta. Cada idioma. Siempre al día.",
    sub: "Tus clientes escanean el código QR en la mesa y ven tu carta en el móvil: en su idioma, con fotos y precios actualizados. Tú lo gestionas todo en un solo lugar.",
    ctaStart: "Empieza gratis",
    ctaDemo: "Ver una carta de ejemplo",
  },
  steps: {
    title: "Cómo funciona",
    items: [
      {
        title: "Regístrate y añade tus platos",
        body: "Categorías, precios, fotos. Directamente en el navegador, sin instalar nada.",
      },
      {
        title: "Pon el código QR en la mesa",
        body: "Imprime el código y listo. Tus clientes no necesitan ninguna app.",
      },
      {
        title: "Cambia lo que cambie",
        body: "Un precio nuevo, el plato del día: online en segundos, sin reimprimir.",
      },
    ],
  },
  included: {
    title: "Todo incluido",
    hint: "Lo que tu carta puede hacer, sin coste adicional.",
    price: "incluido",
    items: [
      {
        name: "Carta en varios idiomas",
        note: "con traducción automática para clientes de cualquier país",
      },
      {
        name: "Fotos, alérgenos y etiquetas",
        note: "cada plato con imagen y declaración clara",
      },
      {
        name: "Cambia precios en segundos",
        note: "sin imprenta, sin pegatinas",
      },
      {
        name: "Código QR para imprimir",
        note: "para la mesa, la entrada o un folleto",
      },
      {
        name: "Tu propia web y dominio",
        note: "tu carta vive bajo tu nombre",
      },
      {
        name: "Sin app para los clientes",
        note: "escanear, leer y pedir como siempre",
      },
    ],
  },
  pricing: {
    title: "La cuenta, por favor",
    hint: "La carta digital es gratis.",
    lines: [
      { name: "Carta digital", price: "0 €" },
      { name: "Web estándar con carta y contacto", price: "0 €" },
      { name: "Conectar tu propio dominio", price: "0 €" },
      { name: "Publicidad", price: "ninguna" },
    ],
    totalLabel: "Total al mes",
    total: "0 €",
    note: "Crea tu restaurante y tu carta está online. ¡Gracias por tu visita!",
    extrasTitle: "Si lo quieres, añade",
    extras: [
      { name: "Soporte por chat y correo", price: "9 € / mes" },
      { name: "Web a medida, diseñada por nosotros", price: "pago único, desde 490 €" },
    ],
  },
  finale: {
    title: "¿Online esta misma noche?",
    sub: "Crea tu restaurante, añade tus platos y tu carta estará disponible al instante en tu propia dirección.",
    cta: "Empieza gratis",
  },
  phone: {
    restaurant: "Casa Pulpo",
    menuTitle: "Carta",
    category: "Recomendaciones",
    dishes: [
      { name: "Sopa del día", price: "6,50 €" },
      { name: "Pulpo a la brasa", price: "18,90 €" },
      { name: "Tarta de chocolate", price: "7,20 €" },
    ],
  },
};
